module.exports = __webpack_public_path__ + "img/WBPad-规则.8832f48c.svg";